import React, { useEffect } from "react";
import FormListingFiltersStyles from "../formlistingfilters/FormListingFilters.styles";
import FormSectionStyles from "../../FormSection.styles";
import styles from "./../FormsListing.styles"
import FormsStatePayrollStyles from "./FormsStatePayroll.styles";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import RichGrid from "../../../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import PaymentDataService from "../../../../../services/PaymentDataService";
import Heading from "../../../../components/heading/Heading";
import { HEADING } from "../../../../components/heading/constants/constants";
import { componentKey, setSelectedState, setSelectedForm, setFormList, setSelectedTaxYear, setSelectedPayer, setPayerList, setPaginationState, setStatePayrollSubmittedFormsList, setSelectedForms, setHighlightedStatePayrollForm, setStatePayrollFormDetailsDrawerOpen, setSubmitStatePayrollFormFees, setDeleteStatePayrollFormsModalOpen, setStatePayrollSubmitForThisPayerModal, setShowPaymentNotAllowedPopup, setUrlFormIdParam, setUrlPayerIdParam, setLoadStatePayrollFormsDataState, setAssignStatePayrollFormsToReviewersModal, setShouldGetSubmittedStatePayrollFormsGridData, setSubmitForThisPayerReviewedCheckbox, setSubmitForThisPayerReviewedCheckboxModal, setFormStatus } from "./FormStatePayrollSlice";
import { useDispatch, useSelector } from "react-redux";
import { getStateList, getFormList, getPayerList, getStatePayrollSubmittedFormsList, viewStatePayrollPDF, loadStatePayrollFormsData, submitForSinglePayer, deleteStatePayrollForms, createStatePayrollZipForDownloadAll, assignFormToReviewers } from "./FormStatePayrollSaga";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import Label from "../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import Payer from "../../../../../libs/utility/Payer";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import FormDetailsDrawer from "../formdetailsdrawer/FormDetailsDrawer";
import Button from "../../../../components/button/Button";
import { PAGE_PERMISSIONS } from "../../../dashboard/constants/constant";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ConfirmationPopup from "../../../../components/popup/confirmationpopup/ConfirmationPopup";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Loadable from "../../../../components/loadable/Loadable";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import { isAccessAllowed } from "../../../dashboard/hooks/userHooks";
import General from "../../../../../libs/utility/General";
import { STATUS_OPTIONS } from "./constants";
import { STATE_PAYROLL_FILING_HISTORY_VALUE, HISTORY_QUERY_PARAMS, HISTORY_SECTION_ROUTES } from '../../../history/Constants'
import useTxNavigate from "../../../../../libs/txnavigate/TxNavigateHook";
import { useUserPermissionsInfo } from "../../../dashboard/hooks/userHooks";
import PaymentDrawer from "../../../components/paymentdrawer/PaymentDrawer";
import { QUERY_PARAMS, FORM_SECTION_CONSTANTS } from '../../constants'
import { FORM_LISTING_LOADING_STATES, FORM_LISTING_MESSAGE_MAP } from "../constants";
import IconDropdown from "../../../../components/dropdown/icondropdown/IconDropdown";
import AssignMembersTable from "../../../components/addpayernew/assignmembers/assignmemberstable/AssignMembersTable";
import { USER_TYPE } from "../../../../../libs/customhooks/constants";
import { useUserTypeInfo } from "../../../../../libs/customhooks/useUserTypeInfo";

export default function FormsStatePayroll() {
    useGarbageCollector(componentKey)
    const dispatch = useDispatch();
    const navigate = useTxNavigate();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const { permissions } = useUserPermissionsInfo();
    const { userType } = useUserTypeInfo();

    const { stateList, selectedState, formList, selectedForm, taxYearList, selectedTaxYear, payerList, selectedPayer,
        paginationState, statePayrollSubmittedFormsList, selectedReadyToSubmitForms,
        isTINHidden, highlightedStatePayrollForm, statePayrollFormDetailsDrawerOpen, setStatePayrollFormDetails,
        statePayrollformDetailsDrawerLoader, loadStatePayrollFormsDataState, submitStatePayrollFormFees, deleteStatePayrollFormsModal, filtersLoadingState,
        loadingState, statePayrollSubmitForThisPayerOpen, reloadSubmitGridData, urlFormIdParam, urlPayerIdParam,
        assignStatePayrollFormsToReviewersModal, submitForThisPayerReviewedCheckboxModal, submitForThisPayerReviewedCheckbox, shouldGetSubmittedStatePayrollFormsGridData,
        isFormGridLoading, formStatus } = useSelector(state => state[componentKey]);

    useEffect(() => {
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATE_ID)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)
        const statusParamFromUrl = queryParams.get(QUERY_PARAMS.STATUS)
        
        if (statusParamFromUrl) {
            const findSelectedStatusRecord = STATUS_OPTIONS.find(status => status?.value === statusParamFromUrl);
            if (findSelectedStatusRecord) {
                dispatch(setFormStatus(findSelectedStatusRecord));
            }
        }
        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))
        dispatch(getStateList({ urlStateParam: stateParamFromUrl, urlTaxYearParam: taxYearParamFromUrl }));
    }, [])

    useEffect(() => {
        if (selectedState?.value) {
            dispatch(getFormList({ stateName: selectedState?.value, urlFormIdParam: urlFormIdParam }));
        } else {
            dispatch(setFormList([]));
        }
        dispatch(setSelectedForm({ label: "", value: "" }))
        dispatch(setPayerList([]));

    }, [selectedState])


    useEffect(() => {
        if (selectedForm?.FormId) {
            dispatch(getPayerList({ formId: selectedForm?.value, urlPayerIdParam: urlPayerIdParam }));
        } else {
            dispatch(setPayerList([]));
        }

        dispatch(setStatePayrollSubmittedFormsList([]));
        dispatch(setSelectedForms([]));
        dispatch(setPayerList([]));
        dispatch(setSelectedPayer({ label: "", value: "" }))

    }, [selectedForm])


    useEffect(() => {
        if (selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label !== "") {
            handleGetSubmittedStatePayrollForms(paginationState?.page, paginationState?.pageSize, true)
        }
        else {
            dispatch(setStatePayrollSubmittedFormsList([]));
            dispatch(setSelectedForms([]));
        }
    }, [selectedPayer])

    useEffect(() => {
        if (loadStatePayrollFormsDataState.state) {
            dispatch(submitForSinglePayer({
                PayerId: selectedPayer?.value,
                FormName: selectedForm?.label,
                TaxYear: selectedTaxYear?.value,
                PayerName: selectedPayer?.label,
                selectedReadyToSubmitForms: selectedReadyToSubmitForms?.length ? selectedReadyToSubmitForms : [highlightedStatePayrollForm],
                statePayrollSubmittedFormsList,
                fromDrawer: loadStatePayrollFormsDataState?.fromDrawer,
                highlightedForm: highlightedStatePayrollForm,
                considerAllSelectedFormsForThisPayer: loadStatePayrollFormsDataState?.considerAllSelectedFormsForThisPayer,
            }));
            if (loadStatePayrollFormsDataState?.fromVerificationPopup) {
                dispatch(setSubmitForThisPayerReviewedCheckboxModal(false));
                dispatch(setSubmitForThisPayerReviewedCheckbox(false));
            }
            dispatch(setLoadStatePayrollFormsDataState({ state: false, type: "" }))
        }
    }, [loadStatePayrollFormsDataState]);

    useEffect(() => {
        if (reloadSubmitGridData) {
            handleGetSubmittedStatePayrollForms(paginationState?.page, paginationState?.pageSize, false);
        }
    }, [reloadSubmitGridData])

    useEffect(() => {
        if (shouldGetSubmittedStatePayrollFormsGridData.gridData) {
            handleGetSubmittedStatePayrollForms(paginationState?.page, paginationState?.pageSize, shouldGetSubmittedStatePayrollFormsGridData?.updatePagination ?? false)
            dispatch(setShouldGetSubmittedStatePayrollFormsGridData({
                gridData: false,
                updatePagination: false,
            }))
        }
    }, [shouldGetSubmittedStatePayrollFormsGridData])

    const handleGetSubmittedStatePayrollForms = (pageNumber, pageSize, updatePagination = false) => {
        if (selectedForm?.value && selectedTaxYear?.value && selectedPayer?.value && formStatus?.value) {
            dispatch(getStatePayrollSubmittedFormsList({
                pageNumber: pageNumber,
                pageSize: pageSize,
                jsonPreferences: statePayrollSubmittedFormsList?.length ? Forms.getJsonPreferences(statePayrollSubmittedFormsList, statePayrollSubmittedFormsList) : null,
                payerId: selectedPayer?.PayerDetailId,
                formId: selectedForm?.value,
                taxYear: selectedTaxYear?.value,
                formname: selectedForm?.label,
                statustype: formStatus?.value
            }))
        }
        if (updatePagination) {
            dispatch(setPaginationState({ page: 1, Skip: 0 }));
        }
    }

    const DRAWER_ACTION_BUTTONS = [
        ...(isAccessAllowed(PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS) && !General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName) ? [{
            itemName: "Submit for this Payer",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    if (Object.keys(highlightedStatePayrollForm)?.length != 0) {
                        dispatch(loadStatePayrollFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, fromVerificationPopup: false, fromDrawer: true, considerAllSelectedFormsForThisPayer: true }))
                    } else {
                        dispatch(addNotifications({ heading: "To continue, please select a form!", message: "Form not selected" }));
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }

            }
        }] : []),
        {
            itemName: "Edit",
            onClick: () => {
                navigate(`/forms/createnew?StateName=${selectedState?.value?.toUpperCase()}&FormName=${selectedForm?.FormName1}&Year=${selectedTaxYear?.value}&FormRecordId=${highlightedStatePayrollForm.FormId}&page=${FORM_SECTION_CONSTANTS.SUBMIT_FORMS}&${QUERY_PARAMS.ALLOW_PAYER_RECIPIENT_SELECTION}=true`)
            },
            permissions: PAGE_PERMISSIONS.EDIT_FORM
        },
        {
            itemName: "View PDF", onClick: () => {
                if (Object.keys(highlightedStatePayrollForm)?.length != 0) {
                    dispatch(viewStatePayrollPDF({ highlightedStatePayrollForm, selectedForm, selectedPayer, viewOnly: true }))
                }
            },

        },
        {
            itemName: "Delete",
            onClick: () => {
                if (Object.keys(highlightedStatePayrollForm)?.length !== 0) {
                    dispatch(setDeleteStatePayrollFormsModalOpen({ state: true, fromDrawer: true }));
                }
            },
            permissions: PAGE_PERMISSIONS.DELETE_FORM
        },
    ]

    const STATE_PAYROLL_FORM_LISTING_COLUMNS = [
        {
            field: "date",
            header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...FormsStatePayrollStyles.text, ...FormsStatePayrollStyles.date }}>Date</Label>,
            renderLogic: (row, idx) => <span style={{ ...FormsStatePayrollStyles.text, ...FormsStatePayrollStyles.date }}>{row.Date}</span>
        },
        {
            field: "tin",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={FormsStatePayrollStyles.text}>{Payer.getPayerTINByIdType(row.TINType, row.TIN, isTINHidden)}</span>
        },
        {
            field: "name",
            header: <Label weight={LABEL_WEIGHT[700]}>Name</Label>,
            renderLogic: (row, idx) => <span style={FormsStatePayrollStyles.text}>{row.Name}</span>
        },
        {
            field: "operations",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Operations</Label >,
            renderLogic: (row, idx) => <div style={FormsStatePayrollStyles.actionButtons}>
                <Button onClickCb={() => {
                    dispatch(setHighlightedStatePayrollForm(row));
                    dispatch(setSubmitStatePayrollFormFees({}))
                    dispatch(setStatePayrollFormDetailsDrawerOpen(true));
                    dispatch(loadStatePayrollFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, fromVerificationPopup: false, fromDrawer: true }));
                }}>Actions</Button>
            </div>
        },
    ]

    const ACTION_BUTTON_DROPDOWN_ITEM = [
        ...(General.hasAccessToUserType(userType, [USER_TYPE.MEMBER_USER]) && isAccessAllowed(PAGE_PERMISSIONS.SUBMIT_FOR_REVIEW, permissions) ? [{
            itemName: "Submit for Review",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    if (selectedReadyToSubmitForms?.length) {
                        dispatch(loadStatePayrollFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, fromVerificationPopup: false, fromDrawer: false }));
                    } else {
                        dispatch(addNotifications({ heading: "To continue, please select a form!", message: "Form not selected" }));
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
                if (selectedReadyToSubmitForms?.length) {
                    dispatch(setAssignStatePayrollFormsToReviewersModal(true));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To delete multiple forms, please select at least one form" }));
                }
            },


        }] : []),
        {
            itemName: "Download Multiple PDF",
            onClick: () => {
                if (selectedReadyToSubmitForms?.length) {
                    dispatch(createStatePayrollZipForDownloadAll({ payer: selectedPayer, formTypeID: selectedForm?.value, formName: selectedForm?.FormName1, statePayrollSubmittedFormsList, selectedReadyToSubmitForms }));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To donwload multiple PDFs, please select a form" }));
                }
            },
        },
        {
            itemName: "Delete",
            onClick: () => {
                if (selectedReadyToSubmitForms?.length) {
                    dispatch(setDeleteStatePayrollFormsModalOpen({ state: true, fromDrawer: false }));
                } else {
                    dispatch(addNotifications({ heading: "To continue, please select a form!", message: "To delete multiple forms, please select at least one form" }));
                }
            },
            permissions: PAGE_PERMISSIONS.DELETE_FORM
        },
        ...(isAccessAllowed(PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS) && !General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName) ? [{
            itemName: "Submit for this payer",
            onClick: () => {
                if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
                    if (selectedReadyToSubmitForms?.length) {
                        dispatch(loadStatePayrollFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, fromVerificationPopup: false, fromDrawer: false }));
                    } else {
                        dispatch(addNotifications({ heading: "To continue, please select a form!", message: "Form not selected" }));
                    }
                } else {
                    dispatch(setShowPaymentNotAllowedPopup(true))
                }
            }
        }] : []),
    ]

    return (
        <>
            <div>
                <div style={FormListingFiltersStyles.headerText}>
                    <Heading type={HEADING.H3} customStyle={FormListingFiltersStyles.viewingYear}>You are currently viewing the forms for</Heading>
                </div>

                <div style={FormSectionStyles.dropdownContainer}>
                    <div style={FormSectionStyles.selectDropdown}>
                        <Loadable
                            currentState={filtersLoadingState.state}
                            loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_STATE_LIST_LOADING]}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}
                        >
                            <SelectDropdown
                                label="State"
                                name="selectedState"
                                placeHolder="Select a state"
                                value={selectedState}
                                options={stateList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedState(selectedOption));
                                    dispatch(setSelectedForm({ label: "", value: "" }))
                                    dispatch(setSelectedPayer({ label: "", value: "" }))
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.STATE_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                                isClearable={false}
                            />
                        </Loadable>
                        <Loadable
                            currentState={filtersLoadingState.state}
                            loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}>
                            <SelectDropdown
                                label="Form"
                                name="selectedForm"
                                placeHolder="Select a Form"
                                value={selectedForm}
                                options={formList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedForm(selectedOption));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.FORM_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                            />
                        </Loadable>
                        <Loadable
                            currentState={filtersLoadingState.state}
                            loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_TAX_YEARS_LOADING]}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}>
                            <SelectDropdown
                                label="Tax Year"
                                name="selectedTaxYear"
                                placeHolder="Select a Tax year"
                                value={selectedTaxYear}
                                options={taxYearList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedTaxYear(selectedOption));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                    }
                                    setQueryParams(queryParams);
                                }}
                            />
                        </Loadable>
                        <Loadable
                            currentState={filtersLoadingState.state}
                            loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_LOADING]}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}>
                            <SelectDropdown
                                label="Payer"
                                name="Payer"
                                placeHolder="Select a Payer"
                                value={selectedPayer}
                                options={payerList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedPayer(selectedOption));
                                    dispatch(setStatePayrollSubmittedFormsList([]));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                                isClearable={false}
                            />
                        </Loadable>
                        <Loadable
                            currentState={filtersLoadingState.state}
                            loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_STATUS_LOADING]}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}>
                            <SelectDropdown
                                label="Status"
                                name="Status"
                                placeHolder="Select Status"
                                value={formStatus}
                                options= {STATUS_OPTIONS}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setFormStatus(selectedOption));
                                    dispatch(setShouldGetSubmittedStatePayrollFormsGridData({
                                        gridData: true,
                                        updatePagination: true,
                                    }))
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.STATUS, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.STATUS)
                                    }
                                    setQueryParams(queryParams);
                                }}
                                isClearable={false}
                            />
                        </Loadable>
                        {statePayrollSubmittedFormsList.length ? <Loadable>
                            <IconDropdown
                                label="Bulk Actions"
                                dropdownItems={ACTION_BUTTON_DROPDOWN_ITEM}
                                dropdownContainerStyles={{ ...styles.actionDropdown, ...styles.actionbuttonleft }}
                                styles={styles.actionDropdownLabel}
                                dropdownMenuStyle={styles.actionDropdownMenu}
                            /></Loadable> : null}
                    </div>
                </div>
                <div style={FormSectionStyles.gridContainer}>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING, FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_LOADING, FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_LOADING]}
                        messageMap={FORM_LISTING_MESSAGE_MAP}
                        isNewLoadable={true}
                        isFullWidth={false}>
                        {!isFormGridLoading && selectedForm?.label !== "" && selectedPayer?.label !== "" && selectedTaxYear?.label !== "" && formStatus?.label !== "" && <>
                            {statePayrollSubmittedFormsList?.length ? <RichGrid
                                selectable={true}
                                data={statePayrollSubmittedFormsList}
                                columns={STATE_PAYROLL_FORM_LISTING_COLUMNS}
                                extractRowKey={(row) => row.FormId}
                                selectedRows={selectedReadyToSubmitForms}
                                onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setSelectedForms(selectedData))}
                                onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedForms(selectedData))}
                                paginationProps={{
                                    skip: paginationState?.Skip,
                                    take: paginationState?.pageSize,
                                    takeOptions: ROW_SELECTION_OPTIONS,
                                    total: paginationState?.total,
                                    onChangeTakeCb: (newTake) => {
                                        dispatch(setPaginationState({ ...paginationState, pageSize: newTake, page: 1, Skip: 0 }));
                                        handleGetSubmittedStatePayrollForms(1, newTake, false)
                                    },
                                    onChange: (take, skip) => {
                                        dispatch(setPaginationState({ ...paginationState, pageSize: take, Skip: skip, page: Math.ceil((take + skip) / take) }))
                                        handleGetSubmittedStatePayrollForms(Math.ceil((take + skip) / take), take, false)
                                    }
                                }}
                            /> : !statePayrollSubmittedFormsList?.length && selectedForm?.label !== "" && <b style={{ display: "flex", justifyContent: "center" }}>No Data Found!</b>
                            }
                        </>}
                    </Loadable>


                </div>
                {statePayrollFormDetailsDrawerOpen &&
                    <FormDetailsDrawer
                        isOpen={statePayrollFormDetailsDrawerOpen}
                        title={`${selectedForm.label} Form Details`}
                        highlightedForm={highlightedStatePayrollForm}
                        onCloseCb={() => {
                            dispatch(setStatePayrollFormDetailsDrawerOpen(false));
                            dispatch(setHighlightedStatePayrollForm({}));
                        }}
                        actionDropdown={DRAWER_ACTION_BUTTONS}
                        feeData={submitStatePayrollFormFees}
                        setStatePayrollFormDetails={setStatePayrollFormDetails}
                        statePayrollSubmittedFormsList={statePayrollSubmittedFormsList}
                        selectedForm={selectedForm}
                        selectedPayer={selectedPayer}
                        selectedTaxYear={selectedTaxYear}
                        drawerLoader={statePayrollformDetailsDrawerLoader}
                        loadingState={loadingState}
                    />
                }

                {deleteStatePayrollFormsModal?.state &&
                    <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={`Are you sure want to delete the selected forms?`}
                        iconName={VEC_ICON_NAME.WARNING_ICON}
                        isOpen={deleteStatePayrollFormsModal?.state}
                        preserveLoaderChildMount={true}
                        confirmationButtonProps={{
                            onConfirmationCb: () => {
                                if (!deleteStatePayrollFormsModal?.fromDrawer && selectedReadyToSubmitForms?.length) {
                                    dispatch(deleteStatePayrollForms({ statePayrollSubmittedFormsList, toDeleteData: selectedReadyToSubmitForms, selectedForm, fromDrawer: deleteStatePayrollFormsModal?.fromDrawer }));
                                }
                                else if (deleteStatePayrollFormsModal?.fromDrawer) {
                                    dispatch(deleteStatePayrollForms({ statePayrollSubmittedFormsList, toDeleteData: [highlightedStatePayrollForm], selectedForm, fromDrawer: deleteStatePayrollFormsModal?.fromDrawer }));
                                }
                                else {
                                    dispatch(addNotifications({ heading: "To delete, please select a form!", message: "Form not selected" }));
                                    dispatch(setStatePayrollFormDetailsDrawerOpen(false));
                                }
                                dispatch(setDeleteStatePayrollFormsModalOpen({ state: false }));
                            },
                            confirmationButtonText: "Delete",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY
                        }}
                        cancelButtonProps={{
                            onCancelCb: () => dispatch(setDeleteStatePayrollFormsModalOpen({ state: false })),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER
                        }}
                        showClose={false}
                    />

                }

                {
                    statePayrollSubmitForThisPayerOpen &&
                    <PaymentDrawer
                        isOpen={statePayrollSubmitForThisPayerOpen}
                        onCloseCb={() => {
                            dispatch(setStatePayrollSubmitForThisPayerModal(false))
                            dispatch(setStatePayrollFormDetailsDrawerOpen(false));
                            dispatch(setHighlightedStatePayrollForm({}))
                        }}
                        fees={submitStatePayrollFormFees}
                        calculateEstimatedTax={true}
                        paymentServiceFunctionCb={submitStatePayrollFormFees != null ? PaymentDataService.submitPayment : null}
                        onPaymentSuccessCb={() => handleGetSubmittedStatePayrollForms(paginationState?.page ?? 1, paginationState?.pageSize ?? 200, false)}
                        filingFeeLabel={`Form Submit ${selectedForm?.label}`}
                        showOnSuccessNavigationBtns={true}
                        onSuccessNavigationBtnsArr={[
                            {
                                label: "Go to dashboard",
                                type: BUTTON_TYPE.PRIMARY,
                                customStyle: {},
                                onClickCb: () => navigate(`/`),
                            },
                            {
                                label: "Go to state payroll filing history",
                                type: BUTTON_TYPE.PRIMARY,
                                customStyle: {},
                                onClickCb: () => {
                                    const filingHistoryQueryObj = {
                                        [HISTORY_QUERY_PARAMS.PAGE]: STATE_PAYROLL_FILING_HISTORY_VALUE,
                                        [QUERY_PARAMS.STATE_ID]: selectedState?.value,
                                        [QUERY_PARAMS.FORM_ID]: selectedForm?.value,
                                        [QUERY_PARAMS.TAX_YEAR]: selectedTaxYear?.value,
                                        [QUERY_PARAMS.PAYER_ID]: selectedPayer?.value
                                    };
                                    const filingHistoryQueryStr = General.convertObjToQueryString(filingHistoryQueryObj);
                                    navigate(`/${HISTORY_SECTION_ROUTES.HISTORY}?${filingHistoryQueryStr}`);
                                },
                            },
                        ]}
                    />
                }

                {
                    submitForThisPayerReviewedCheckboxModal && <Popup
                        isPopupOpen={submitForThisPayerReviewedCheckboxModal}
                        childrenStyles={styles.modalBody}
                        onCloseCb={() => {
                            dispatch(setSubmitForThisPayerReviewedCheckboxModal(false))
                            dispatch(setSubmitForThisPayerReviewedCheckbox(false));
                        }}
                    >
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING]} isNewLoadable={true}
                            messageMap={FORM_LISTING_MESSAGE_MAP}
                        >
                            <CheckboxWLabel
                                checked={submitForThisPayerReviewedCheckbox}
                                label="I have reviewed and verified the data for submission"
                                onChangeCb={(e) => dispatch(setSubmitForThisPayerReviewedCheckbox(e.target.checked))}
                            />

                            <Button
                                style={styles.okButton}
                                disabled={!submitForThisPayerReviewedCheckbox}
                                onClickCb={() => {
                                    dispatch(setSubmitForThisPayerModal(true))
                                    dispatch(setSubmitForThisPayerReviewedCheckboxModal(false))
                                    dispatch(setSubmitForThisPayerReviewedCheckbox(false));
                                }}>Ok</Button>
                        </Loadable>
                    </Popup>
                }

                {
                    assignStatePayrollFormsToReviewersModal && <AssignMembersTable
                        isPopup={true}
                        isPopupOpen={assignStatePayrollFormsToReviewersModal}
                        title='Assign Forms to Reviewer(s)'
                        payerDetails={selectedPayer}
                        onPopupCloseCb={() => dispatch(setAssignStatePayrollFormsToReviewersModal(false))}
                        onAssignCb={(selectedReviewers) => dispatch(assignFormToReviewers({
                            formIds: selectedReadyToSubmitForms?.length == 0 ? [highlightedStatePayrollForm?.FormId] : selectedReadyToSubmitForms.map(formData => formData.FormId),
                            payerId: selectedPayer?.PayerDetailId,
                            formName: selectedForm?.label,
                            payerName: selectedPayer?.LastName,
                            taxyear: selectedTaxYear?.label,
                            formtypeId: selectedForm?.value,
                            reviewerIds: selectedReviewers,
                        }))}
                    />
                }

            </div>

        </>

    )
}
